import { navigate as internalNavigate } from '@reach/router';
import { isBrowser } from '../../utils';
import { isRelativeUrl } from '../../utils/helpers';

function buildSmartUrl(url) {
  // Drop Gatbsy-focus-wrapper
  var dropAnchor = url.split('#gatsby-focus-wrapper')[0];
  return dropAnchor;
}

function customNavigate(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isBrowser()) {
    var isInternal = isRelativeUrl(url) && !options.isBlank && !options.isExternal;

    if (isInternal) {
      internalNavigate(url);
    } else if (options.isBlank) {
      window.open(url);
    } else {
      window.location = url;
    }
  }
}

export { customNavigate, buildSmartUrl };